import { render } from "./V2.vue?vue&type=template&id=1ea45664&scoped=true"
import script from "./V2.vue?vue&type=script&lang=js"
export * from "./V2.vue?vue&type=script&lang=js"

import "./V2.vue?vue&type=style&index=0&id=1ea45664&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea45664"]])

export default __exports__